import request from './request';

export const ROLE_GET_LIST = 'amp2.RoleSrv/GetSpecifyRoleList';

export default class Role {
  static async fetch(params) {
    try {
      const data = await request.post(ROLE_GET_LIST, params);
      return data.roles;
    } catch (error) {
      if (error.code === 404) {
        // 这里是找不到角色，正常错误可忽略
        return [];
      }
      throw error;
    }
  }
}
